/**
 * Central internal linking map for SEO content clusters.
 */

import { BLOG_STUB_SLUGS } from '../Pages/Blog/blogRegistry';

export const VERTICAL_PATHS = {
  aerial: '/aerial-surveying',
  location: '/location-visualisation',
  ecommerce: '/ecommerce-3d',
};

/** @type {Record<string, { vertical?: string, blogSlugs: string[] }>} */
export const BLOG_CLUSTER_LINKS = {
  'volugraph-capture-guide': {
    blogSlugs: [],
  },
  'aerial-footage-to-3d-gaussian-splat': {
    vertical: VERTICAL_PATHS.aerial,
    blogSlugs: [
      'drone-to-3d-model-without-photogrammetry',
      'gaussian-splatting-vs-photogrammetry',
      '360-video-to-3d-scene',
    ],
  },
  'e-commerce-products': {
    vertical: VERTICAL_PATHS.ecommerce,
    blogSlugs: [
      '3d-products-for-shopify',
      'gaussian-splatting-vs-matterport',
    ],
  },
  'drone-to-3d-model-without-photogrammetry': {
    vertical: VERTICAL_PATHS.aerial,
    blogSlugs: ['aerial-footage-to-3d-gaussian-splat', 'gaussian-splatting-vs-photogrammetry'],
  },
  'gaussian-splatting-vs-matterport': {
    vertical: VERTICAL_PATHS.location,
    blogSlugs: ['gaussian-splatting-vs-photogrammetry', 'aerial-footage-to-3d-gaussian-splat'],
  },
  'gaussian-splatting-vs-photogrammetry': {
    vertical: VERTICAL_PATHS.aerial,
    blogSlugs: ['drone-to-3d-model-without-photogrammetry', 'aerial-footage-to-3d-gaussian-splat'],
  },
  '3d-products-for-shopify': {
    vertical: VERTICAL_PATHS.ecommerce,
    blogSlugs: ['e-commerce-products', 'gaussian-splatting-vs-matterport'],
  },
  '360-video-to-3d-scene': {
    vertical: VERTICAL_PATHS.location,
    blogSlugs: ['aerial-footage-to-3d-gaussian-splat', 'volugraph-capture-guide'],
  },
};

function publishedBlogSlugs(slugs) {
  return slugs.filter((s) => !BLOG_STUB_SLUGS.has(s));
}

export const VERTICAL_RELATED_BLOGS = {
  [VERTICAL_PATHS.aerial]: publishedBlogSlugs([
    'aerial-footage-to-3d-gaussian-splat',
    'volugraph-capture-guide',
  ]),
  [VERTICAL_PATHS.location]: publishedBlogSlugs(['volugraph-capture-guide', 'aerial-footage-to-3d-gaussian-splat']),
  [VERTICAL_PATHS.ecommerce]: publishedBlogSlugs(['e-commerce-products', 'volugraph-capture-guide']),
};

